import { render, staticRenderFns } from "./CreateUpdateMaterialReagent.vue?vue&type=template&id=52ebe836&scoped=true&"
import script from "./CreateUpdateMaterialReagent.vue?vue&type=script&lang=js&"
export * from "./CreateUpdateMaterialReagent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ebe836",
  null
  
)

export default component.exports